export default (initialState = {}) => ({
  durationSeconds: Number(initialState.durationSeconds) || 5,
  redirectUrl: initialState.redirectUrl || "",
  viewBoxSize: Number(initialState.viewBoxSize) || 160,
  strokeWidth: Number(initialState.strokeWidth) || 10,
  timerTextColor: initialState.timerTextColor || "#296C53",

  animationStartTime: null,
  animationFrameId: null,
  completionRatio: 0,
  secondsRemaining: 0,

  get radius() {
    return (this.viewBoxSize - this.strokeWidth) / 2
  },

  get circumference() {
    return 2 * Math.PI * this.radius
  },

  get strokeDashOffset() {
    return this.circumference * (1 - this.completionRatio)
  },

  init() {
    this.secondsRemaining = this.durationSeconds
    setTimeout(() => this.startCountdown(), 50)

    this._pageshowHandler = (event) => {
      if (event.persisted) this.startCountdown()
    }
    window.addEventListener("pageshow", this._pageshowHandler)
  },

  destroy() {
    this.stopAnimation()
    window.removeEventListener("pageshow", this._pageshowHandler)
  },

  startCountdown() {
    this.stopAnimation()
    this.animationStartTime = null
    const totalMs = this.durationSeconds * 1000

    const tick = (timestamp) => {
      if (!this.animationStartTime) this.animationStartTime = timestamp
      const elapsed = timestamp - this.animationStartTime

      this.completionRatio = Math.min(elapsed / totalMs, 1)
      this.secondsRemaining = Math.max(
        1,
        Math.ceil(this.durationSeconds * (1 - this.completionRatio)),
      )

      if (this.completionRatio < 1) {
        this.animationFrameId = requestAnimationFrame(tick)
      } else {
        this.handleRedirect()
      }
    }

    this.animationFrameId = requestAnimationFrame(tick)
  },

  stopAnimation() {
    if (this.animationFrameId) cancelAnimationFrame(this.animationFrameId)
    this.animationFrameId = null
  },

  handleRedirect() {
    if (!this.redirectUrl) return
    window.location.assign(this.redirectUrl)
  },
})
